export const REQUEST_RESPONSE = 'REQUEST_RESPONSE'
export const UPDATE_CAMPAIGNS = 'UPDATE_CAMPAIGNS'
export const SET_LOADING = 'SET_NPRINTING_LOADING'
export const SET_CAMPAIGN_LOADING = 'SET_CAMPAIGN_LOADING'
export const UPDATE_CAMPAIGN_RESULT = 'UPDATE_CAMPAIGN_RESULT'
export const UPDATE_USERS_REQUESTS = 'UPDATE_USERS_REQUESTS'
